import { render, staticRenderFns } from "./ModalEventDescription.vue?vue&type=template&id=475e5974&scoped=true"
import script from "./ModalEventDescription.vue?vue&type=script&lang=js"
export * from "./ModalEventDescription.vue?vue&type=script&lang=js"
import style0 from "./ModalEventDescription.vue?vue&type=style&index=0&id=475e5974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e5974",
  null
  
)

export default component.exports